import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import ThanksCallout from "../../../../src/components/ThanksCallout";
import findelement from "../../../../assets/images/docs/findelement.png";
import workerselection from "../../../../assets/images/docs/devtools/workerselection.png";
import whatsapplight from "../../../../assets/images/blogs/pp29/whatsapp-light.png";
import whatsappdark from "../../../../assets/images/blogs/pp29/whatsapp-dark.png";
import passkeys from "../../../../assets/images/blogs/pp29/passkeys.png";
import customvaluespreset from "../../../../assets/images/blogs/pp29/custom.png";
import iframeinspect from "../../../../assets/images/blogs/pp29/iframe-inspect.png";
import customselectors from "../../../../assets/images/docs/outline/customselectors2.png";
import flexviz from "../../../../assets/images/blogs/pp29/flexviz.png";
import livesnippet from "../../../../assets/images/blogs/pp29/livesnippet.png";
import statetoggles from "../../../../assets/images/docs/elements/statetoggles.png";
import startingstyletoggle from "../../../../assets/images/blogs/pp29/startingstyletoggle.png";
import a11ytab29 from "../../../../assets/images/blogs/pp29/a11ytab.png";
import acctreedesc from "../../../../assets/images/blogs/pp29/acctreedesc.png";
import loadperfwarning from "../../../../assets/images/blogs/pp29/loadperfwarning.png";
import shadowdomsearch from "../../../../assets/images/blogs/pp29/shadowdomsearch.png";
import installsnippets from "../../../../assets/videos/blogs/pp29/installsnippet.mp4";
import networkvideo from "../../../../assets/videos/blogs/pp29/network.mp4";
import paneltabs from "../../../../assets/videos/blogs/pp29/paneltabs.mp4";
import networkheaders from "../../../../assets/images/blogs/pp29/network-headers.png";
import networkoverview from "../../../../assets/images/blogs/pp29/network-overview.png";
import networkrequests from "../../../../assets/images/blogs/pp29/network-requests.png";
import networkstats from "../../../../assets/images/blogs/pp29/network-stats.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  PolypaneIntro,
  ThanksCallout,
  findelement,
  workerselection,
  whatsapplight,
  whatsappdark,
  passkeys,
  customvaluespreset,
  iframeinspect,
  customselectors,
  flexviz,
  livesnippet,
  statetoggles,
  startingstyletoggle,
  a11ytab29,
  acctreedesc,
  loadperfwarning,
  shadowdomsearch,
  installsnippets,
  networkvideo,
  paneltabs,
  networkheaders,
  networkoverview,
  networkrequests,
  networkstats,
  React
};